module.exports = __webpack_public_path__ + "static/media/smarttelefon.97907054.mp3";